// `Address` and `Coordinate` (spec/08-api-design.md §3).
//
// Stored as `jsonb` on the `organization` and `venue` rows (spec/04-domain-model.md), so the shape
// is the contract's to fix. The field names are the neutral ones a postal address has in every
// market rather than India's, so opening a second country is settings and translations, not a
// migration (spec/03 §10).
import { z } from "../zod.js";
import { CountryCodeSchema } from "./scalars.js";
export const AddressSchema = z
    .object({
    line1: z.string().min(1).max(120),
    line2: z.string().max(120).optional(),
    /** A landmark; in India this is how an address is actually given. */
    landmark: z.string().max(120).optional(),
    /** City, town or village. */
    locality: z.string().min(1).max(80),
    /** State, province or union territory. Drives GST place-of-supply (spec/03 §10). */
    region: z.string().min(1).max(80),
    /** PIN code in India; postcode, ZIP elsewhere. Format varies by country, so only length is fixed. */
    postalCode: z.string().min(3).max(16),
    country: CountryCodeSchema,
})
    .openapi('Address', { description: 'A postal address.' });
/** A point on the map: a venue's pin, used by `GET /v1/public/venues?lat=&lng=` (spec/08 §4.3). */
export const CoordinateSchema = z
    .object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
})
    .openapi('Coordinate', { description: 'A WGS 84 latitude and longitude in degrees.' });
//# sourceMappingURL=address.js.map